<template>


    <Dialog v-model:visible="visibleDialog" modal header="You are killed from server." :style="{ width: '25rem' }">
            
        <div class="flex flex-column align-items-start gap-3 mb-5">
            <span class="font-semibold w-6rem">{{$t('dialogs.kline_dialogue.reason')}}</span><span class="font-semibold w-6rem">{{ reason ? reason : "Unknown" }}</span>
        </div>
        <div class="flex flex-column align-items-start gap-3 mb-5" v-if="killedBy">
            <span class="font-semibold w-6rem">{{$t('dialogs.kline_dialogue.by')}}</span><span class="font-semibold w-6rem">{{ killedBy }}</span>
        </div>

    </Dialog>

</template>

<script>
export default {
    name: "KlineDialog",
    data() {
        return {
            visibleDialog: false,
            reason: "",
            killedBy: "",
        }
    },

    methods: {
        showDialog(data) {
            this.reason = data.reason;
            this.killedBy = data.by;
            this.visibleDialog = true
        },

    }

}
</script>